import {
  TeamsTestChat,
  TeamsTestChatReminders,
  TeamsTestChatSend,
  TeamsTestChatStatus,
} from '@myrewards/contracts';
import { queryOptions } from '@tanstack/react-query';
import type { z } from 'zod';
import { request } from './client';

/**
 * Admin › AI › Teams test chat (APP-089, local only): a named tester plays the Teams app as
 * someone. The server runs the assistant on each message at once and answers with the chat.
 */

export const teamsTestKeys = {
  all: ['teams-test'] as const,
  status: ['teams-test', 'status'] as const,
  chat: (personId: string) => ['teams-test', 'chat', personId] as const,
};

export const teamsTestStatusQuery = queryOptions({
  queryKey: teamsTestKeys.status,
  queryFn: ({ signal }) =>
    request('/api/v1/admin/teams-test', { schema: TeamsTestChatStatus, signal }),
  staleTime: 30_000,
});

export function teamsTestChatQuery(personId: string) {
  return queryOptions({
    queryKey: teamsTestKeys.chat(personId),
    queryFn: ({ signal }) =>
      request(`/api/v1/admin/teams-test/chat?personId=${encodeURIComponent(personId)}`, {
        schema: TeamsTestChat,
        signal,
      }),
  });
}

/** Writes as them, or presses a button on a card, and waits for the assistant's answer. */
export function sendTeamsTest(input: z.input<typeof TeamsTestChatSend>): Promise<TeamsTestChat> {
  return request('/api/v1/admin/teams-test/chat', {
    method: 'POST',
    body: TeamsTestChatSend.parse(input),
    schema: TeamsTestChat,
  });
}

/** Posts what a real day would remind them of now: approvals waiting, choices open. */
export function sendTeamsReminders(personId: string): Promise<TeamsTestChatReminders> {
  return request('/api/v1/admin/teams-test/reminders', {
    method: 'POST',
    body: { personId },
    schema: TeamsTestChatReminders,
  });
}
